var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-popover",
    {
      attrs: {
        "popover-class": _vm.popoverClass,
        open: _vm.open,
        disabled: _vm.disabled,
        placement: _vm.placement,
        "auto-hide": _vm.autoHide,
      },
    },
    [
      _vm._t("trigger"),
      _c("template", { slot: "popover" }, [
        _vm.isIconPresent
          ? _c("div", { staticClass: "popover-icon" }, [_vm._t("icon")], 2)
          : _vm._e(),
        _c("div", { staticClass: "popover-content" }, [
          _c("div", { staticClass: "popover-header" }, [_vm._t("header")], 2),
          _c("div", { staticClass: "popover-body" }, [_vm._t("body")], 2),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }